module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0136.jpg?v=262cd5b2";